import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0078FF',
    },
    secondary: red,
    error: {
      main: red.A400,
    },
    background: {
      default: '#FAFAFC',
    },
  },
});

export default theme;
